/* Mystic Modesty — newsletter signup reveal
 * On submit of any newsletter form (Sahara draft OR live legacy theme),
 * shows the WELCOME10 code on-page (instant UX) and submits the email
 * to Shopify in the background.
 */
(function () {
  'use strict';
  try {
    var CODE = 'WELCOME10';

    function isValidEmail(s) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(s || '').trim());
    }

    function buildReveal() {
      var el = document.createElement('div');
      el.className = 'mm-newsletter-success';
      el.setAttribute('data-mm-reveal', '');
      el.innerHTML =
        '<p class="mm-newsletter-success__heading">Welcome to the family.</p>' +
        '<p class="mm-newsletter-success__copy">Your 10% off code:</p>' +
        '<p class="mm-newsletter-success__code" data-mm-code>' + CODE + '</p>' +
        '<div class="mm-newsletter-success__actions">' +
          '<button type="button" class="mm-newsletter-success__copybtn" data-mm-copy>Copy code</button>' +
          '<button type="button" class="mm-newsletter-success__shopbtn" data-mm-shop hidden>Shop now</button>' +
        '</div>' +
        '<p class="mm-newsletter-success__hint">We\'ll also email it to you. Use it at checkout.</p>';
      return el;
    }

    /**
     * Hide title / entry / etc. of the surrounding popup or footer block,
     * and update the close / shop-now buttons to make sense post-submit.
     *
     * - Popup mode: Shop now becomes a "close popup" button (drops them right
     *   back where they were). Maybe-later relabels to "Close".
     * - Footer mode: Shop now stays hidden (nothing useful to "close").
     */
    function hideContextChrome(form, reveal) {
      try {
        var shopBtn = reveal.querySelector('[data-mm-shop]');
        var popup = form.closest && form.closest('newsletter-popup');

        if (popup) {
          var title = popup.querySelector('.newsletter-popup__title');
          if (title) title.style.display = 'none';
          var entry = popup.querySelector('.newsletter-popup__entry');
          if (entry) entry.style.display = 'none';

          var closeBtn = popup.querySelector('button[id^="ModalClose"]');
          if (closeBtn) {
            closeBtn.textContent = 'Close';
          }

          // Show + wire Shop now → close the popup, leave user where they are
          if (shopBtn) {
            shopBtn.hidden = false;
            shopBtn.addEventListener('click', function (ev) {
              ev.preventDefault();
              ev.stopPropagation();
              try {
                if (typeof popup.hide === 'function') {
                  popup.hide();
                } else if (closeBtn) {
                  closeBtn.click();
                }
              } catch (err) {
                if (closeBtn) closeBtn.click();
              }
            });
          }
          return;
        }

        // Footer / inline mode — walk up looking for sibling headings/text to hide
        var node = form.parentNode;
        for (var depth = 0; depth < 4 && node; depth++) {
          var hideMe = node.querySelectorAll(':scope > h1, :scope > h2, :scope > h3, :scope > h4, :scope > h5, :scope > h6, :scope > p');
          if (hideMe && hideMe.length > 0) {
            for (var k = 0; k < hideMe.length; k++) {
              var h = hideMe[k];
              if (!h.contains(form) && !h.contains(reveal)) {
                h.style.display = 'none';
              }
            }
            break;
          }
          node = node.parentNode;
        }
        // Footer keeps Shop now hidden (no popup to close from down here)
      } catch (e) {}
    }

    /**
     * A form is a newsletter form if ANY of:
     *   - it has class .newsletter-form (Sahara)
     *   - its id starts with "newsletter-" (Sahara variant)
     *   - it contains an input[name="contact[email]"] AND a hidden input[name="contact[tags]"] whose value contains "newsletter"
     */
    function isNewsletterForm(f) {
      try {
        if (f.classList && f.classList.contains('newsletter-form')) return true;
        if (f.id && f.id.indexOf('newsletter-') === 0) return true;
        var emailInput = f.querySelector('input[name="contact[email]"]');
        var tagsInput = f.querySelector('input[name="contact[tags]"]');
        if (emailInput && tagsInput && /newsletter/i.test(tagsInput.value || '')) return true;
      } catch (e) {}
      return false;
    }

    function attach(form) {
      if (!form || form.__mmRevealBound) return;
      form.__mmRevealBound = true;

      // CAPTURE PHASE — runs before any other handler (incl. Sahara's
      // newsletter-popup onSubscribe which closes the popup, and any
      // theme-level form submitters). stopImmediatePropagation kills
      // those handlers entirely.
      form.addEventListener('submit', function (e) {
        try {
          var emailInput = form.querySelector('input[type="email"], input[name="contact[email]"]');
          var email = emailInput ? emailInput.value.trim() : '';
          if (!isValidEmail(email)) {
            // Let Shopify's native validation handle it (don't prevent)
            return;
          }

          // BLOCK every other handler + the native submit
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();

          // Insert reveal as sibling of the form, then hide the form
          var parent = form.parentNode;
          if (!parent) return;

          // Avoid double reveals
          if (parent.querySelector('[data-mm-reveal]')) {
            form.style.display = 'none';
            return false;
          }

          var reveal = buildReveal();
          form.style.display = 'none';
          parent.insertBefore(reveal, form);

          // Hide title / subtext, change close button label etc.
          hideContextChrome(form, reveal);

          // Wire copy button
          var copyBtn = reveal.querySelector('[data-mm-copy]');
          if (copyBtn) {
            copyBtn.addEventListener('click', function () {
              try {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                  navigator.clipboard.writeText(CODE).then(function () {
                    copyBtn.textContent = 'Copied!';
                    setTimeout(function () { copyBtn.textContent = 'Copy code'; }, 1800);
                  });
                } else {
                  var ta = document.createElement('textarea');
                  ta.value = CODE;
                  document.body.appendChild(ta);
                  ta.select();
                  document.execCommand('copy');
                  document.body.removeChild(ta);
                  copyBtn.textContent = 'Copied!';
                  setTimeout(function () { copyBtn.textContent = 'Copy code'; }, 1800);
                }
              } catch (err) {}
            });
          }

          // Background submit to Shopify (capture the email + tag as newsletter)
          try {
            var fd = new FormData(form);
            fetch(form.action || '/contact', {
              method: 'POST',
              body: fd,
              redirect: 'manual',
              credentials: 'same-origin',
              headers: { 'Accept': 'text/html' },
            }).catch(function () {});
          } catch (err) {}

          return false;
        } catch (err) {
          if (window.console && console.warn) console.warn('mm-newsletter-reveal:', err);
        }
      }, true);   // ← capture phase
    }

    function init() {
      try {
        var forms = document.querySelectorAll('form');
        Array.prototype.forEach.call(forms, function (f) {
          if (isNewsletterForm(f)) attach(f);
        });
      } catch (e) {}
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);

    // Belt-and-suspenders: also re-init on a short delay in case something defers form rendering
    setTimeout(init, 500);
    setTimeout(init, 2000);
  } catch (e) {
    if (window.console && console.warn) console.warn('mm-newsletter-reveal failed to init:', e);
  }
})();
